import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useContract } from '../hooks/useContracts';
import { ContractWizard } from './ContractWizard';

export function EditContractWizard() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { contract, loading } = useContract(id!);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!contract) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Contract not found</h2>
          <button
            onClick={() => navigate('/contracts')}
            className="text-primary-600 hover:text-primary-700"
          >
            Return to contracts
          </button>
        </div>
      </div>
    );
  }

  return <ContractWizard existingContract={contract} isEditing={true} />;
}

